import Section from "../Section";

export default class InfoColumns extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

  }
}
